import * as React from 'react';
import { BaseFormFieldProps } from '../../form/FormField';
import { ContentState, EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import styled from '@emotion/styled';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

const Container = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
`;

interface RTEInputState {
  editorState: any;
  value: string;
}

class RTEInput extends React.Component<BaseFormFieldProps, RTEInputState> {
  state = {
    editorState: this.props.value
      ? EditorState.createWithContent(convertFromRaw(JSON.parse(this.props.value)))
      : EditorState.createEmpty(),
    value: this.props.value,
  };

  IsJsonString = (str) => {
    try {
      const res = JSON.parse(str);
      if(typeof res !== "object") return false;
    } catch (e) {
      return false;
    }
    return true;
  };

  componentWillReceiveProps(nextProps) {
    // const currentValue = this.props.value;
    const currentValue = this.state.value;
    const nextValue = nextProps.value;
    const currentState = this.state.editorState;
    let nextState = null;

    if (currentValue !== nextValue) {
      if (nextValue === '') {
        nextState = EditorState.createEmpty();
      } else if (this.IsJsonString(nextValue)) {
        nextState = EditorState.push(currentState, convertFromRaw(JSON.parse(nextValue)));
      } else if (/^/.test(nextValue)) {
        const blocksFromHtml = htmlToDraft(nextValue);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        nextState = EditorState.createWithContent(contentState);
      } else {
        nextState = EditorState.push(currentState, ContentState.createFromText(nextValue));
      }

      const currentStateSelection = currentState.getSelection();
      if (currentStateSelection.getHasFocus()) {
        nextState = EditorState.acceptSelection(nextState, currentStateSelection);
      }
      this.setState({
        editorState: nextState,
      });
    }
  }

  handleChange = (editorState) => {
    const { onChange } = this.props;
    const content = draftToHtml(convertToRaw(editorState.getCurrentContent()));

    // const jsonStr = JSON.stringify(content);
    this.setState({
      editorState,
      value: content,
    }, () => {
      onChange(content);
    });
  };

  render() {
    const { editorState } = this.state;

    return (
      <Container>
        {this.props.readOnly ? (
          <div dangerouslySetInnerHTML={{ __html: draftToHtml(convertToRaw(editorState.getCurrentContent())) }} />
        ) : (
          <Editor editorState={editorState} onEditorStateChange={this.handleChange} />
        )}
      </Container>
    );
  }
}

export default RTEInput;
